import gql from "graphql-tag"

const query = gql`
  mutation ConfirmRewardPaymentOrder($tenantId: String!, $orderId: String!) {
    confirmRewardPaymentOrder(tenantId: $tenantId, orderId: $orderId)
  }
`

export const toString = query.loc.source.body

export default query
